<template>
  <v-expansion-panel>
    <v-expansion-panel-header>{{ label }} - {{ slots.length }} Slot{{ slots.length === 1 ? '' : 's' }}</v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-row v-for="({ text, slots, hours }, index) of slots" :key="index">
        <v-col>
          <v-text-field :value="text" label="Time/Duty" outlined hide-details @change="(text) => updateSlot(index, { text })" />
        </v-col>
        <v-col>
          <v-text-field :value="slots" label="Students Desired" type="number" min="1" outlined hide-details @change="(slots) => updateSlot(index, { slots })" />
        </v-col>
        <v-col>
          <v-text-field :value="hours" label="Hours" type="number" min=".5" max="10" step=".5" outlined hide-details @change="(hours) => updateSlot(index, { hours })">
            <template #append-outer>
              <v-btn icon style="margin-top:-8px" @click="removeSlot(index)">
                <v-icon color="error">fal fa-times-circle</v-icon>
              </v-btn>
            </template>
          </v-text-field>
        </v-col>
      </v-row>
      <v-btn small @click="addSlot()">Add Slot</v-btn>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<script>
import { ref, watch } from '@vue/composition-api'

export default {
  props: {
    label: String
  },
  setup (props, { emit }) {
    const slots = ref([])

    function addSlot () {
      slots.value.push({ text: '', slots: 1, hours: 0.5 })
    }
    function removeSlot (index) {
      slots.value.splice(index, 1)
    }
    function updateSlot (index, value) {
      const obj = { ...slots.value[index], ...value }
      console.log('Updating slot obj: ', obj)
      slots.value.splice(index, 1, obj)
    }

    watch(slots, () => {
      console.log('Emitting update')
      emit('update', slots.value)
    })

    return {
      slots,
      addSlot,
      removeSlot,
      updateSlot
    }
  }
}
</script>
